export enum ReportGraphTypes {
    BAR = "BAR",
    PIE = "PIE",
    STACKED_BAR = "STACKED_BAR",
    BAR_AND_LINE = "BAR_AND_LINE",
}